import { useMutation, useQueryClient } from "@tanstack/react-query";
import qcareApi from "./qcareApi";


const addDiscrepancy = async ({ dataBody, prereport }) => {

    let revalidate
    let url

    if (prereport) {url = 'prereport/edit-discrepancy'; revalidate = 'prereport'}
    else {url = '/report/edit-discrepancy'; revalidate = 'report'}

    const { data } = await qcareApi.put(url, dataBody)
    return {data, revalidate}
};

// ------------------------- HOOKS -------------------------

export const useAddDiscrepancy = () => {
    const queryClient = useQueryClient()
    return useMutation(addDiscrepancy, {
        onSuccess: async(item) => await queryClient.invalidateQueries([item.revalidate]) 
    })
}